<style lang="stylus">
        .user-Topbar
            position relative
            height 56px
            // background-color #f1f3fb
            display flex
            justify-content flex-end
            align-items center
            border-bottom 1px solid #f2f2f2
            z-index 11
            .search-box
                position absolute
                left 50%
                top 8px
                transform translateX(-50%)
                height 28px
                width 30%
                max-width 600px
                display flex
                justify-content space-between
                align-items center
                border-radius 5px
                overflow hidden
                @media screen and (max-width: 1260px)
                    left 10px
                    width 200px
                    transform translateX(0)
                @media screen and (max-width: 890px)
                    display none
                input
                    flex 1
                    border none
                    border 1px solid #e0e0e0
                    border-radius 5px 0 0 5px
                    border-right none
                    height 100%
                    width 100%
                    background transparent
                    outline none
                    text-indent 8px
                div
                    background var(--themeColor);
                    height 100%
                    color #ffffff
                    padding 0 12px
                    cursor pointer
                    line-height 28px
            .topbar-rightbox
                margin-right: 40px
                display flex
                align-items center
                height 100%
                z-index 2
                >div{
                    margin-left 16px;
                }
                .topbar-activity
                    @media screen and (max-width: 1215px)
                        display none
                .topbar-icon
                    position relative
                    width 24px
                    height 24px
                    cursor pointer
                    user-select none
                .msg-icon{
                    margin-left: 8px
                    svg {
                        width 24px
                        height 24px
                        color #222
                    }
                    span {
                        display block
                    }
                    &:hover{
                        display block
                        svg {
                            color var(--themeColor)
                        }
                    }
                }
                .msg-icon-img
                    width: 24px
                .topbar-promotionbox
                    position relative
                    display flex
                    padding-right 20px
                    align-items center
                    height 100%
                    white-space nowrap
                    cursor pointer

                .topbar-download
                    position relative
                    padding 0px 16px 0 12px
                    text-align center
                    line-height 32px
                    color #fff
                    font-size 11px
                    border-radius 6px
                    user-select none
                    cursor pointer
                    background: #017FFF
                    display flex
                    align-items center
                    justify-content center
                    margin-left: 16px
                    // transition all .2s linear
                    &:hover
                        background: var(--themeHover)
                    @media screen and (max-width: 1200px)
                        display none
                .topbar-nalpromo
                    display flex
                    align-items center
                    cursor pointer
                    user-select none
                    @media screen and (max-width: 900px)
                        display none
                .topbar-buy
                    position relative
                    display flex
                    align-items center
                    height 100%
                    white-space nowrap
                    min-width 99px
                    .vip-btn
                        position relative
                        height 32px
                        padding 0px 16px 0px 12px
                        color #FFD298
                        border-radius: 6px
                        background: linear-gradient(104deg, #381A00 0%, #1D0D00 100%);
                        line-height 32px
                        text-align center
                        font-size 11px
                        cursor pointer
                        width 100%
                        white-space nowrap
                        overflow hidden
                        text-overflow ellipsis
                        transition all .2s linear
                        display flex
                        justify-content center

                        &:hover
                             background linear-gradient(0deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.08) 100%), linear-gradient(104deg, #381A00 0%, #1D0D00 100%)
                        // @media screen and (max-width: 1200px)
                        //     display none
                    .menu-img
                        width: 24px;
                        height: 24px;
                        margin-right 4px
                        margin-top 4px
                .btn-wrapper
                    position relative
                    padding: 8px 0;
                    .vip-popover
                        position absolute
                        top 48px
                        left 0
                        z-index 1000
                        display none
                        @media screen and (max-width: 1200px)
                            right 0
                            left unset
                    &:hover
                        .vip-popover
                            display block !important

                .topbar-buy2
                    .menu-img
                        padding 0

                .topbar-returnBoard
                    display flex
                    justify-content center
                    align-items center
                    padding 0 12px
                    height 32px
                    color #fff
                    font-size 12px
                    border-radius 5px
                    margin-right 20px
                    user-select none
                    cursor pointer
                    background #017EFF
                    // transition all .2s linear
                    svg
                        width 20px
                        height 20px
                        margin-right 4px
                    &:hover
                        background #0977ea
    .lang-menu{
        position relative
        display: flex;
        justify-content:space-between;
        align-items: center;
        >p {
            width 100%
            textOverflow()
        }
        .lang-content{
            right 155px
            top 0
            position absolute
            background #fff
            border-radius: $common-border-radius;
            box-shadow $box-shadow
            overflow hidden
            padding: 6px
            .lang-item{
                height 30px
                padding 0 10px
                white-space nowrap
                font-size 12px
                cursor pointer
                line-height 30px
                border-radius: 6px;
            }
            .active-lang{
                color var(--themeColor)
            }
            .lang-item:hover{
                background $common-hover-color
            }

        }
        &:after{
            //margin-right: 15px
            margin-left: auto;
            content: '';
            display: block;
            width: 0;
            height: 0;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 6px solid #77818c;
        }
    }

    .switch-to-edrawai
        display flex
        align-items center
        justify-content center
        height 32px
        padding 8px 12px
        background linear-gradient(to right,rgba(119, 85, 255, 0.25),rgba(119, 85, 255, 0.15))
        border-radius 6px
        color #533DCB
        font-size 12px
        font-weight 500
        cursor pointer
        position relative
        img.logo
            width 16px
            height 16px
            margin-right 6px
        &:hover
            opacity 0.8
        img.star
            position absolute
            right 0
            top 0

    .download-box
        position absolute
        top 41px
        right 0
        padding: 24px
        background #FFFFFF
        border-radius 8px
        box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.05), 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
        cursor default
        &:after
            content ""
            position absolute
            left 0
            top 0
            width 100%
            height 100%
            border 1px solid rgba(0, 0, 0, 0.08)
            border-radius 8px
            pointer-events none
        .topbox
            display flex
            column-gap 16px
            .leftbox
                position relative
                display flex
                flex-direction column
                align-items center
                width 224px
                height 256px
                padding 24px
                border-radius 8px
                &:after
                    content ""
                    position absolute
                    left 0
                    top 0
                    width 100%
                    height 100%
                    border 1px solid rgba(0, 0, 0, 0.08)
                    border-radius 8px
                    pointer-events none
                img
                    width 56px
                    height 56px
                    margin-bottom 24px
                .leftbox-title
                    font-size 14px
                    font-weight 700
                    color #000
                    line-height 18px
                    margin-bottom 8px
                .leftbox-content
                    font-size 12px
                    color rgba(34, 34, 34, 1)
                    line-height 16px
                    text-align center
                .downloadbtn
                    margin-top auto
                    width 176px
                    height 28px
                    border-radius 6px
                    padding 0 10px
                    display flex
                    justify-content center
                    align-items center
                    background #017fff
                    cursor pointer
                    p
                        font-size 12px
                        color #fff
                        textOverflow()
                    &:hover
                        background #0075eb
                &.en-left
                    width 352px
                    height auto
                    .leftbox-content
                        margin-bottom 24px
                    .downloadbtn
                        width 100%
            .rightbox
                display flex
                flex-wrap wrap
                row-gap 16px
                width 210px
                .rightbox-content
                    position relative
                    display flex
                    align-items center
                    column-gap 12px
                    width 100%
                    height 120px
                    border-radius 8px
                    &:after
                        content ""
                        position absolute
                        left 0
                        top 0
                        width 100%
                        height 100%
                        border 1px solid rgba(0, 0, 0, 0.08)
                        border-radius 8px
                        pointer-events none
                    .cover
                        display flex
                        padding 0 12px
                        align-items center
                        .half
                            position absolute
                            right 0
                            top 0
                        .cover-img
                            width 56px
                            height 56px
                            margin-right 8px
                        .rightbox-text
                            font-size 12px
                            font-weight 700
                            line-height 16px
                            color #000
                            text-align left
                            .gray
                                font-weight 400
                                color rgba(0, 0, 0, 0.5)
                                margin-top 8px
                                font-size 11px
                    .qrcode
                        display none
                        width 96px
                        height 96px
                    &:hover
                        padding 0 57px
                        .cover
                            display none
                        .qrcode
                            display block
                        &:after
                            border-color #017fff
        .download-link
            width 100%
            text-align center
            margin-top 24px
            a
                display block
                font-size 12px
                line-height 16px
                color #017fff





    // 覆盖iview组件样式
    .badge-modify
        transform translateX(70%) scale(0.8) !important
    .user-Topbar.isTeamsApp
        .topbar-leftbox-mobile
            display none
        @media screen and (max-width: 500px)
            justify-content space-between
            .topbar-leftbox-mobile
                display block
                padding-left 15px
                svg
                    fill: #424242;
                    stroke: #424242;
                    width: 28px;
                    height: 28px
</style>

<template>
    <div class="user-Topbar" :class="{ 'new-bg': isWorkbench, isTeamsApp: isTeamsApp }">
        <div class="topbar-leftbox-mobile" v-if="isTeamsApp">
            <iconSymbol :name="'listViewIcon'" @click.native="showLeftPanel = true"></iconSymbol>
        </div>
        <div class="topbar-rightbox" id="topBarBox">
            <!-- <div class="topbar-promotionbox" v-if="!vipState && showPromotionBtn" @click="toPromotion()">
                <img :src="require('@/home/assets/img/12-12-topbar.png')" alt="">
            </div> -->
            <!-- <div class="topbar-promotionbox" v-if="!vipState && showBlackFridayBtn && this.lang==='en'"
            @click="toBlackFriday()"> -->
            <component :is="useAD" :adType="'topbar'"></component>
            <!-- <img :src="require('@/home/assets/img/BlackFridayBtn.png')" alt=""> -->
            <!-- </div> -->

            <div class="topbar-nalpromo" v-if="nalPromoData && nalPromoData.img" @click="nalPromoVip">
                <img :src="nalPromoData.img" :style="{ width: `${nalPromoData.w}px`, height: `${nalPromoData.h}px` }" alt="" />
            </div>

            <!-- v-if="!isPrivate && !isPlugin && !isTeamsApp" -->

            <!-- en promodal -->
            <template v-if="!internal && lang == 'en'">
                <div class="btn-wrapper" @mouseenter="hoverVipPopover">
                    <div
                        class="topbar-buy topbar-buy2"
                        v-if="!vipState && !isPlugin && !isPrivate && !isTeamsApp"
                        data-locate="vipbuy"
                        @click="toVip2"
                    >
                        <div class="vip-btn" :title="$t('vip')">
                            <img class="menu-img" :src="require(`@/home/assets/img/topbar-vip2.svg`)" alt="" />
                            <span>Upgrade for Free</span>
                        </div>
                    </div>
                    <div class="vip-popover" ref="vipPopover">
                        <NoVipPopover @toVip="toVip2" />
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="btn-wrapper" @mouseenter="hoverVipPopover">
                    <div class="topbar-buy" v-if="!vipState && !isPlugin && !isPrivate && !isTeamsApp" data-locate="vipbuy" @click="toVip">
                        <div class="vip-btn" id="vip-btn" :title="$t('vip')">
                            <img class="menu-img" :src="require(`@/home/assets/img/topbar-vip.svg`)" alt="" />
                            <span>{{ $t("vip") }}</span>
                        </div>
                    </div>
                    <div class="vip-popover" ref="vipPopover">
                        <NoVipPopover @toVip="toVip" />
                    </div>
                </div>
            </template>
            <div class="switch-to-edrawai" v-if="!internal && vipState && !isPrivate && !isPlugin && !isTeamsApp" @click="switchToEdrawai">
                <img class="logo" src="@/home/assets/img/edrawai-logo.svg" alt="" />
                <span>Switch To Edraw.AI</span>
                <img class="star" src="@/home/assets/img/edrawai-star.svg" alt="" />
            </div>
            <div
                v-if="!isPrivate && !isPlugin && !isTeamsApp"
                class="topbar-download"
                data-locate="downloadpc"
                @mouseenter="handleDownloadMouseEnter"
                @mouseleave="handleDownloadMouseLeave"
                v-click-outside="clickClose"
            >
                <img class="menu-img" :src="require(`@/home/assets/img/topbar-download.svg`)" alt="" style="width: 24px; height: 24px" />
                <p>{{ $t("download") }}</p>
                <div class="download-box" v-show="showExpand">
                    <div class="topbox">
                        <div class="leftbox" :class="{ 'en-left': !internal }">
                            <img :src="require(`@/home/assets/img/${downloadText}.png`)" alt="" />
                            <p class="leftbox-title">{{ $t(downloadText) }}</p>
                            <p class="leftbox-content">{{ $t("downloadWindowsTips") }}</p>
                            <div class="downloadbtn" @click="toDownloadPc()">
                                <p>{{ $t("downloadNow") }}</p>
                            </div>
                        </div>
                        <div class="rightbox" v-if="internal">
                            <div class="rightbox-content">
                                <div class="cover">
                                    <img class="half" src="@/home/assets/img/qrcode-half.png" alt="" />
                                    <img class="cover-img" src="@/home/assets/img/qrcode-mini.png" alt="" />
                                    <div class="rightbox-text">
                                        <p>{{ $t("miniTitle") }}</p>
                                        <p class="gray">{{ $t("miniContent") }}</p>
                                    </div>
                                </div>
                                <img class="qrcode" src="@/home/assets/img/miniprogram/miniprogram.png" alt="" />
                            </div>
                            <div class="rightbox-content">
                                <div class="cover">
                                    <img class="half" src="@/home/assets/img/qrcode-half.png" alt="" />
                                    <img class="cover-img" src="@/home/assets/img/qrcode-app.png" alt="" />
                                    <div class="rightbox-text">
                                        <p>{{ $t("appTitle") }}</p>
                                        <p class="gray">{{ $t("appContent") }}</p>
                                    </div>
                                </div>
                                <img class="qrcode" src="@/home/assets/img/downloadpage.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="download-link">
                        <a :href="downloadPage" target="_blank">{{ $t("downloadLink") }}</a>
                    </div>
                </div>
            </div>

            <div class="topbar-icon" v-if="isPrivate && isAdmin" @click="toManage">
                <img class="msg-icon-img" src="@/home/assets/img/user/topbar/admin.svg" alt="" />
            </div>

            <HelpMenu ref="helpMenu" :userInfo="userInfo" :from="'home'" @openHelpMenu="openHelpMenu" />

            <div class="topbar-icon msg-icon" v-if="!isInclowdz && !isPrivate && !isPlugin && !isTeamsApp" v-click-outside="userMsgBlur">
                <!-- 使用 iview 角标组件，做未读条数展示 -->
                <Badge class-name="badge-modify" :dot="isNewMsg">
                    <iconSymbol name="topbar_msg" @click.native="clickMsg"></iconSymbol>
                </Badge>
            </div>

            <UserMenu v-if="!isInclowdz && !isPlugin" :userInfo="userInfo" :vipState="vip" :from="'home'" />

            <div class="topbar-returnBoard" v-if="isBoard" @click="back2Board">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.25 6.75L9 12L14.25 17.25" stroke="white" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                返回BoardMix
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { EDRAWMAX_USE_AD } from "@/env/";
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import HelpMenu from "@/public/components/helpmenu/helpmenu.vue";
    import UserMenu from "@/public/components/userMenu/userMenu.vue";
    import NoVipPopover from "@/app/components/Modals/NoVipPopover.vue";
    import { isMac, isLinux } from "@/public/utils/customVue";
    import { downloadPC } from "@/public/utils/tool.js";

    // @Component 修饰符注明了此类为一个 Vue 组件

    @Component({
        components: {
            HelpMenu,
            UserMenu,
            NoVipPopover,
        },
    })
    export default class Topbar extends Vue {
        searchValue = "";
        cardWidth: number = 202;
        // isNewMsg: boolean = false
        msgTimer: number;

        get useAD() {
            return EDRAWMAX_USE_AD ? () => import("@/home/parts/activity/AD.vue") : null;
        }
        get isWorkbench() {
            return this.$route.name == "Workbench";
        }

        get nalPromoData() {
            console.log("nalPromo_topbar", this.$store.state.publicStore);
            return this.$store.state.publicStore.nalPromo_topbar;
        }

        showuserNotifyMsgMenu = false;
        isUserMsgBlur: boolean = false;

        showExpand = false;

        get isNewMsg() {
            return this.$store.state.userNotifyMsg.hasNewMsg;
        }

        set isNewMsg(newVal) {
            this.$store.commit("userNotifyMsg/setState", {
                type: "hasNewMsg",
                data: newVal,
            });
        }
        get showLeftPanel() {
            return this.$store.state.showLeftPanel;
        }
        set showLeftPanel(val) {
            this.$store.commit("setState", {
                type: "showLeftPanel",
                data: val,
            });
        }

        get showUserNotifyMsg() {
            return this.$store.state.userNotifyMsg.showUserNotifyMsg;
        }
        set showUserNotifyMsg(newVal) {
            this.$store.commit("userNotifyMsg/setState", {
                type: "showUserNotifyMsg",
                data: newVal,
            });
        }
        openHelpMenu() {
            this.sensors.track("clickQuestionMarkIcon", {
                Catalogues: "helpcenter",
            });
        }

        get userInfo() {
            return this.$store.state.userInfo;
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        get prefixUrl() {
            if (~location.href.indexOf("/online/")) {
                return "/online";
            } else {
                return "";
            }
        }

        openLink(url) {
            if (url == this.urls.accountUrl) {
                url += `?lang=${this.lang}&tend=max`;
                this.$track("Newpage", "account center");
            } else if (url == this.urls.feedbackUrl) {
                this.$track("Newpage", "feedback");
            }
            let newTab = window.open("about:blank");
            newTab.location.href = url;
        }

        toVip() {
            if (this.internal && !this.$validateLogin()) return;
            // if(this.isPC){
            //     (<any>window).$qt.jsCallUpgradeToPremium(0);
            // }else {
            //     this.$store.commit("toPublicStatus", {
            //         type: "showUpgrade",
            //         data: 'showVip'
            //     });
            // }
            let diagramType = "notUseTemplate";
            if (this.$store.state.activeLv3) {
                diagramType = this.$store.state.activeLv3.lv3name;
            } else if (this.$store.state.activeLv2) {
                diagramType = this.$store.state.activeLv2.lv2name;
            } else if (this.$store.state.activeLv1) {
                diagramType = this.$store.state.activeLv1.lv1name;
            }
            this.$gaTrack("Template_templateTypeClickedBeforePurchase", `diagramType: ${diagramType}`);
            this.sensors.track("templateTypeClickedBeforePurchase", {
                Catalogues: "Templates",
                diagram_type: diagramType,
                platform: this.isPC ? "desktop" : "online",
            });
            this.sensors.track("templateTypeClickedBeforePurchase", {
                Catalogues: "Templates",
                diagram_type: diagramType,
                platform: this.isPC ? "desktop" : "online",
            });
            this.sensors.track("templateNameClickedBeforePurchase", {
                Catalogues: "Templates",
                template_name: this.$store.state.tplCenter.activeWork.title ? this.$store.state.tplCenter.activeWork.title : "notUseTemplate",
                platform: this.isPC ? "desktop" : "online",
            });
            this.$openBuyPage("clickUpgradeEntry");
        }
        toVip2() {
            this.$store.commit("toPublicStatus", {
                type: "upgradeTrigger",
                data: "clickUpgradeEntry",
            });
            this.$bus.$emit("togglePromodal", true, 0, 1);
        }
        nalPromoVip() {
            const url = this.nalPromoData.url;
            if (url) {
                const split = /\?/.test(url) ? "&" : "?";
                let params = `${split}custom=${encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })))}`;
                window.open(`${url}${params}`);
            } else {
                this.$openBuyPage("nalPromo_topbar");
            }
        }
        clickClose() {
            this.showExpand = false;
        }
        downloadHandle() {
            if (this.internal) {
                this.showExpand = !this.showExpand;
            } else {
                this.toDownload();
            }
            if (!this.showExpand) {
                this.hiddenMiniprogram();
                this.hiddenAppBox();
            }
        }
        downloadTimer: number | null = null;
        handleDownloadMouseEnter() {
            console.log("showExpand");
            clearTimeout(this.downloadTimer);
            if (!this.showExpand) {
                this.sensors.track("downloadTips_popup", {
                    Catalogues: "downloadEdrawmaxTips",
                    popup_source: "homepage",
                });
            }
            this.showExpand = true;
        }
        handleDownloadMouseLeave() {
            this.downloadTimer = setTimeout(() => {
                this.showExpand = false;
            }, 150);
        }
        downloadMouseEnter(e) {
            console.log(e);
            let rect = e.target.getBoundingClientRect();
            this.$store.commit("setMiniProgram", {
                show: true,
                left: rect.x,
                top: rect.y,
                direction: 2,
            });
        }
        hiddenMiniprogram() {
            this.$store.commit("setMiniProgram", {
                show: false,
            });
        }
        showMiniprogram(e, type) {
            let rect = e.target.getBoundingClientRect();
            let direction = 2;
            this.$store.commit("setMiniProgram", {
                show: true,
                left: rect.x,
                top: rect.y,
                direction: direction,
            });
        }
        showAppBox(e) {
            let rect = e.target.getBoundingClientRect();
            let direction = 2;
            this.$store.commit("setPromotionBox", {
                show: true,
                type: "app",
                left: rect.x,
                top: rect.y,
                direction: direction,
            });
        }
        hiddenAppBox() {
            this.$store.commit("setPromotionBox", {
                show: false,
            });
        }
        toDownload() {
            console.log("download");
            this.showExpand = false;
            let open = (url) => {
                if (this.isPC) {
                    (<any>window).$qt.jsCallOpenUrl(url);
                } else {
                    window.open(url);
                }
            };
            if (this.internal) {
                open("https://www.edrawsoft.cn/download-edrawmax.php");
            } else {
                let url = "https://www.edrawsoft.com/download-edrawmax.html";
                if (this.lang != "en" && this.lang != "zh") {
                    url = `https://www.edrawsoft.com/${this.lang}/download-edrawmax.html`;
                }
                open(url);
            }
        }
        // 11月30
        checkNewMsg() {
            let getMsg = () => {
                let uObj = {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                };
                this.$edApi
                    .checkNewMsg(uObj)
                    .then((e) => {
                        if (e.status == "success") {
                            this.isNewMsg = true;
                        } else {
                            this.isNewMsg = false;
                        }
                    })
                    .catch(() => {
                        clearInterval(this.msgTimer);
                    });
            };
            if (this.msgTimer) {
                clearInterval(this.msgTimer);
            }
            this.msgTimer = setInterval(() => {
                // 半分钟轮询一次
                if (this.userInfo) {
                    clearInterval(this.msgTimer);
                    getMsg();
                    this.msgTimer = setInterval(() => {
                        // 半分钟轮询一次
                        getMsg();
                    }, 10000);
                }
            }, 500);
        }
        clickMsg() {
            this.userMsgFocus();
            if (!this.$validateLogin()) return;
            this.$track("news", "clicknews", `type: ${this.isNewMsg ? "Red" : "no red"}`);
            // 神策埋点
            this.sensors.track("message", {
                Catalogues: "Start",
            });
            let uObj = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
            };
            let getMsg = () => {
                this.$edApi.checkNewMsg(uObj).then((e) => {
                    if (e.status == "success") {
                        this.isNewMsg = true;
                    } else {
                        this.isNewMsg = false;
                    }
                });
            };
            let getAllNotifiedMsg = () => {
                this.$store.dispatch("userNotifyMsg/getNotifiedMsg", {
                    ...uObj,
                    offset: 0,
                    count: 10,
                });
            };
            getAllNotifiedMsg();
            // this.isNewMsg = false;
            clearInterval(this.msgTimer);
            this.msgTimer = setInterval(() => {
                // 半分钟轮询一次
                getMsg();
            }, 10000);
            // let newTab = window.open("about:blank");
            // newTab.location.href = `${this.urls.accountUrl}/message` + `?lang=${this.lang}`;
        }

        userMsgFocus() {
            if (this.$validateLogin()) {
                if (!this.isUserMsgBlur) {
                    this.showUserNotifyMsg = !this.showUserNotifyMsg;
                } else if (this.isUserMsgBlur && this.showUserNotifyMsg == false) {
                    this.showUserNotifyMsg = true;
                } else if (this.isUserMsgBlur && this.showUserNotifyMsg == true) {
                    this.showUserNotifyMsg = false;
                }
            }
        }

        userMsgBlur() {
            if (this.showUserNotifyMsg == true) {
                this.showUserNotifyMsg = false;
                this.isUserMsgBlur = true;
            }
        }

        windowResize() {
            let gap = 20;
            // 1- 确定列数  = 页面的宽度 / 图片的宽度
            let pageWidth: any = document.querySelector(".seach-box").clientWidth;
            let columns = parseInt((pageWidth / (this.cardWidth + gap)).toString());
            let mod = pageWidth % (this.cardWidth * 100 + gap);
            // gap = gap + parseInt(mod / (columns - 1))
            let items = document.querySelector(".seach-box").children as any;
            let arr = [];
            let itemWidth = this.cardWidth;
            var maxHeight = 0;
            for (let i = 0; i < items.length; i++) {
                if (i < columns) {
                    // 2- 确定第一行
                    items[i].style.top = 0;
                    items[i].style.left = (itemWidth + gap) * i + "px";
                    arr.push(items[i].offsetHeight);
                } else {
                    // 其他行
                    // 3- 找到数组中最小高度  和 它的索引
                    var minHeight = arr[0];
                    var index = 0;
                    for (let j = 0; j < arr.length; j++) {
                        if (minHeight > arr[j]) {
                            minHeight = arr[j];
                            index = j;
                        }
                    }
                    // 4- 设置下一行的第一个盒子位置
                    // top值就是最小列的高度 + gap
                    items[i].style.top = arr[index] + gap + "px";
                    // left值就是最小列距离左边的距离
                    items[i].style.left = items[index].offsetLeft + "px";

                    // 5- 修改最小列的高度
                    // 最小列的高度 = 当前自己的高度 + 拼接过来的高度 + 间隙的高度
                    arr[index] = arr[index] + items[i].offsetHeight + gap;
                    if (maxHeight < arr[index]) {
                        maxHeight = arr[index];
                    }
                }

                if (maxHeight < items[i].offsetHeight + gap + items[i].offsetTop) {
                    maxHeight = items[i].offsetTop + items[i].offsetHeight + gap;
                    (<any>document.querySelector(".seach-box")).style.height = maxHeight + "px";
                }
            }
        }
        isAdmin = false;
        toManage() {
            window.open(`${location.origin}${appConfig.sourcePath}auth/admin.html`);
        }
        getUserRoles() {
            let userInfo = this.userInfo;
            this.$edApi
                .getUserRoles({
                    id: userInfo.user_id,
                    token: userInfo.token,
                })
                .then((data) => {
                    const roles = data.data.roles;
                    if (~roles.indexOf("manage") || ~roles.indexOf("admin")) {
                        this.isAdmin = true;
                    }
                });
        }

        back2Board() {
            console.log("back");
            window.parent.postMessage(
                {
                    eventName: "edrawmaxEvent",
                    action: "closeEditor",
                },
                "*"
            );
        }

        get purchaseBubble() {
            return this.$store.state.publicStore.purchaseBubble;
        }

        hoverVipPopover() {
            this.sensors.track("popBuyNowFloatWindow", {
                Catalogues: "payPath",
                is_unlimited_ai: !!this.purchaseBubble,
                trial_vip_benefit: "none",
                upgrade_trigger: "hoverNowFloatWindow",
            });
        }

        get downloadPage() {
            return this.internal
                ? "https://www.edrawsoft.cn/download-edrawmax.html"
                : ["en", "zh", "tw"].includes(this.lang)
                  ? "https://www.edrawsoft.com/download-edrawmax.html"
                  : `https://www.edrawsoft.com/${this.lang}/download-edrawmax.html`;
        }

        get downloadText() {
            if (isMac) {
                return "downloadMac";
            } else if (isLinux) {
                return "downloadLinux";
            }
            return "downloadWindows";
        }

        toDownloadPc() {
            downloadPC(this.internal, this.lang);
            this.sensors.track("downloadTips_click", {
                Catalogues: "downloadEdrawmaxTips",
                click_source: "homepage",
            });
        }

        switchToEdrawai() {
            let url = /dev.edrawmax/.test(location.host) ? "https://dev-en.edraw.ai/app/" : "https://www.edraw.ai/app/";
            if (this.userInfo) {
                const { user_id, token, avatar_url, user_name } = this.userInfo;
                var custom = {
                    user_id,
                    token,
                    avatar_url,
                    user_name,
                };
                url = `${url}?custom=${window.btoa(JSON.stringify(custom))}`;
            }
            this.openLink(url);
        }

        //生命周期
        mounted() {
            if (appConfig.isBuild) {
                this.checkNewMsg();
                document.addEventListener("visibilitychange", () => {
                    let state = document.visibilityState;
                    if (state == "hidden") {
                        clearInterval(this.msgTimer);
                    } else if (state == "visible") {
                        this.checkNewMsg();
                    }
                });
            }
            if (this.isPrivate) {
                this.getUserRoles();
            }
        }

        destroyed() {}

        created() {
            console.log(12354);
            let from = new URLSearchParams(location.search.substr(1)).get("from");
            this.$store.commit("setState", {
                type: "isAd",
                data: !!from,
            });
        }
    }
</script>

<i18n>
{
  "zh": {
    "vip": "开通VIP",
    "logout": "退出",
    "login": "登录",
    "reg": "注册",
    "userCenter": "用户中心",
    "language": "语言设置",
    "feedBack": "反馈中心",
    "userInfo": "作品主页",
    "download": "下载客户端",
    "home": "亿图官网",
    "miniprogram_pc": "桌面端",
    "miniprogram_wx": "小程序",
    "miniprogram_app": "APP",
    "userTask": "新手任务",
    "downloadWindows": "下载 Windows",
    "downloadLinux": "下载 Linux",
    "downloadMac": "下载 Mac",
    "downloadWindowsTips": "下载客户端，享受更专业、稳定、流畅的绘图体验",
    "downloadNow": "立即下载",
    "miniTitle": "微信扫码打开小程序",
    "miniContent": "随时随地查看个人文件",
    "appTitle": "下载 App",
    "appContent": "支持 Android & iOS",
    "downloadLink": "点击查看更多下载内容 >"
  },
  "en": {
    "vip": "Upgrade",
    "logout": "Logout",
    "login": "Login",
    "userCenter": "User Center",
    "language": "Language Setting",
    "feedBack": "Feedback",
    "userInfo": "My home page",
    "download": "Download",
    "home": "Edrawsoft",
    "miniprogram_pc": "Desktop",
    "miniprogram_wx": "Miniprogram",
    "miniprogram_app": "APP",
    "downloadWindows": "EdrawMax for Windows",
    "downloadLinux": "EdrawMax for Linux",
    "downloadMac": "EdrawMax for Mac",
    "downloadWindowsTips": "Download EdrawMax for a more professional, smooth, and stable drawing experience",
    "downloadNow": "Try It Free",
    "miniTitle": "Scan the WeChat code to open the mini program",
    "miniContent": "View personal files anytime, anywhere",
    "appTitle": "Download App",
    "appContent": "Support Android & iOS",
    "downloadLink": "Click here to view more downloads >"
  },
  "fr": {
    "vip": "Passer à Premium",
    "logout": "Se déconnecter",
    "login": "s'identifier",
    "reg": "inscrit",
    "userCenter": "Centre utilisateur",
    "language": "Paramètres de langue",
    "feedBack": "Centre de rétroaction",
    "userInfo": "Ma page d'accueil",
    "download": "Télécharger",
    "downloadWindows": "EdrawMax pour Windows",
    "downloadLinux": "EdrawMax pour Linux",
    "downloadMac": "EdrawMax pour Mac",
    "downloadWindowsTips": "Téléchargez EdrawMax pour une expérience de dessin plus professionnelle, fluide et stable",
    "downloadNow": "Essai gratuit",
    "downloadLink": "Cliquez pour voir plus de téléchargements >"
  },
  "de": {
    "vip": "Upgrade auf Premium Version",
    "logout": "Abmelden",
    "login": "Anmelden",
    "reg": "Registrieren",
    "userCenter": "Kundenzentrum",
    "language": "Sprache",
    "feedBack": "Feedback",
    "userInfo": "Meine Homepage",
    "download": "Herunterladen",
    "downloadWindows": "EdrawMax für Windows",
    "downloadLinux": "EdrawMax für Linux",
    "downloadMac": "EdrawMax für Mac",
    "downloadWindowsTips": "EdrawMax herunterladen, um ein professionelleres, reibungsloses und stabileres Zeichenerlebnis zu erhalten.",
    "downloadNow": "Gratis Testen",
    "downloadLink": "Klicke hier, um weitere Downloads anzusehen. >"
  },
  "jp": {
    "vip": "プロ版にアップグレード",
    "logout": "ログアウト",
    "login": "ログイン",
    "reg": "登録",
    "userCenter": "ユーザーセンター",
    "language": "言語",
    "feedBack": "フィードバック",
    "userInfo": "マイページ",
    "download": "ダウンロード",
    "downloadWindows": "EdrawMax Windows版",
    "downloadLinux": "EdrawMax Linux版",
    "downloadMac": "EdrawMax Mac版",
    "downloadWindowsTips": "EdrawMaxをダウンロードして、よりプロフェッショナルな、スムーズで安定した描画体験を実現",
    "downloadNow": "無料で試す",
    "downloadLink": "その他のダウンロードはこちらをクリックして表示 >"
  },
  "es": {
    "vip": "Actualizar a Premium",
    "logout": "Cerrar sesión",
    "login": "Iniciar sesión",
    "reg": "Regístrate",
    "userCenter": "Centro de usuarios",
    "language": "Configuración de idioma",
    "feedBack": "Feedback",
    "userInfo": "Mi página de inicio",
    "download": "Descargar",
    "downloadWindows": "EdrawMax para Windows",
    "downloadLinux": "EdrawMax para Linux",
    "downloadMac": "EdrawMax para Mac",
    "downloadWindowsTips": "Descarga EdrawMax para disfrutar de una experiencia de dibujo más profesional, fluida y estable",
    "downloadNow": "Probarlo gratis",
    "downloadLink": "Haz clic aquí para ver más descargas >"
  },
  "pt": {
    "vip": "Fazer Upgrade para a Versão Premium",
    "logout": "Desconectar",
    "login": "Conectar",
    "reg": "Registar-se",
    "userCenter": "Centro de Usuário",
    "language": "Configuração de Língua",
    "feedBack": "Feedback",
    "userInfo": "Minha página inicial",
    "download": "Descarregar",
    "downloadWindows": "EdrawMax para Windows",
    "downloadLinux": "EdrawMax para Linux",
    "downloadMac": "EdrawMax para Mac",
    "downloadWindowsTips": "Baixe EdrawMax para uma experiência de desenho mais profissional, suave e estável",
    "downloadNow": "Teste Grátis",
    "downloadLink": "Clique aqui para ver mais downloads >"
  },
  "it": {
    "vip": "Esegui l'Upgrade alla Versione Premium",
    "logout": "Esci",
    "login": "Accedi",
    "reg": "Registrati",
    "userCenter": "Centro Utente",
    "language": "Impostazioni Lingua",
    "feedBack": "Feedback",
    "userInfo": "La mia Homepage",
    "download": "Scarica",
    "downloadWindows": "EdrawMax per Windows",
    "downloadLinux": "EdrawMax per Linux",
    "downloadMac": "EdrawMax per Mac",
    "downloadWindowsTips": "Scarica EdrawMax per un'esperienza di disegno più professionale, fluida e stabile",
    "downloadNow": "Prova gratis",
    "downloadLink": "Clicca qui per visualizzare altri download >"
  },
  "tw": {
    "vip": "升級VIP會員",
    "logout": "登出",
    "login": "登入",
    "reg": "註冊",
    "userCenter": "用戶中心",
    "language": "語言設置",
    "feedBack": "反饋中心",
    "userInfo": "我的主頁",
    "download": "下載"
  },
  "kr": {
    "vip": "VIP회원 업그레이드",
    "logout": "로그아웃",
    "login": "로그인",
    "reg": "가입",
    "userCenter": "사용자 센터",
    "language": "언어 설정",
    "feedBack": "피드백",
    "userInfo": "사용자 정보",
    "download": "데스크탑 버전 다운로드",
    "home": "Edrawsoft 홈페이지"
  },
  "id": {
    "vip": "Tingkatkan",
    "logout": "Keluar",
    "login": "Masuk",
    "reg": "Daftar",
    "userCenter": "Pusat Pengguna",
    "language": "Pengaturan Bahasa",
    "feedBack": "Umpan Balik",
    "userInfo": "Halaman beranda saya",
    "download": "Unduh",
    "home": "Edrawsoft",
    "miniprogram_pc": "Desktop",
    "miniprogram_wx": "Program Mini"
  }
}
</i18n>
